export default function partition(objects, predicate) {
    const valid = []
    const rest = []

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < objects.length; i++) {
        if (predicate(objects[i])) {
            valid.push(objects[i])
        } else {
            rest.push(objects[i])
        }
    }

    return [valid, rest]
}
